if ( typeof Fancybox !== 'undefined' ) {
	Fancybox.bind( '[data-fancybox]', {} );
}
